import React, { useEffect, useRef, useState } from "react";
import { CustomCheckoutOrder } from "../store/core/reducer.ts";
import { formatPrice } from "../utils";
import './SecondDisplay.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ImagePreview } from "../components/ImagePreview.tsx";
import BannerLogo from '../assets/img/display.png'
import { getDepotoLogoSrc } from '../utils'
import {useCore} from "../hooks";

export const SecondDisplay: React.FC = () => {
  const { currency, core } = useCore()
  const depotoLogo = getDepotoLogoSrc(
    'dark',
    core?.services?.oauth?.session?.clientType ?? window.depotoEnv,
  )
  const [currentOrder, setCurrentOrder] = useState<CustomCheckoutOrder>(JSON.parse(window.localStorage.getItem('globalState'))?.core?.currentOrder)
  const [orderItemsContainerHeight, setOrderItemsContainerHeight] = useState<number>(0)
  const [slideshowLinks, setSlideshowLinks] = useState<string[]>(window.localStorage.getItem('depoto_checkout2_2nd_window_slideshow_links')?.split('\n') || [])
  const [slideshowFrameUrl, setSlideshowFrameUrl] = useState<string>('')
  const orderItemsContainerRef = useRef(undefined)
  let frameInterval = undefined

  const updateOrderItemListHeight = () => {
    setOrderItemsContainerHeight(orderItemsContainerRef?.current?.scrollHeight || 0)
  }

  const scrollDownInOrderItemList = () => {
    setTimeout(() => {
      if (orderItemsContainerRef?.current) {
        orderItemsContainerRef.current.scrollTop = orderItemsContainerHeight
      }
    }, 100)
  }
  const readCurrentOrderFromStorage = (storage: any) => {
    const order: CustomCheckoutOrder = JSON.parse(storage?.newValue)?.core?.currentOrder
    setCurrentOrder(order)
    updateOrderItemListHeight()
    setSlideshowLinks(window.localStorage.getItem('depoto_checkout2_2nd_window_slideshow_links')?.split('\n') || [])
    // console.log(window.localStorage.getItem('depoto_checkout2_2nd_window_slideshow_links')?.split('\n'))
  }

  useEffect(() => {
    updateOrderItemListHeight()
    window.addEventListener('storage', readCurrentOrderFromStorage)
    setSlideshowFrameUrl(slideshowLinks[0])
    return () => {
      window.removeEventListener('storage', readCurrentOrderFromStorage)
    }
  }, [])

  useEffect(() => {
    if (orderItemsContainerHeight > 0) {
      scrollDownInOrderItemList()
    }
  }, [orderItemsContainerHeight])

  useEffect(() => {
    if (frameInterval) {
      return
    }
    frameInterval = setInterval(() => {
      const index = slideshowLinks.indexOf(slideshowFrameUrl) + 1
      if (index > slideshowLinks?.length - 1) {
        setSlideshowFrameUrl(slideshowLinks[0])
      } else {
        setSlideshowFrameUrl(slideshowLinks[index])
      }
    }, 5000)
    return () => {
      clearInterval(frameInterval)
      frameInterval = undefined
    }
  }, [slideshowLinks, slideshowFrameUrl])

  return (
    <div className="w-full flex flex-row">
      <div className="w-1/2 bg-white p-5 h-body flex flex-col">
        <div className="display-slideshow scrollable-y overflow-hidden">
          <img src={slideshowFrameUrl || null} alt="slideshow" style={{ width: '100%', height: 'auto' }}></img>
        </div>
        <div className="display-bottom-info flex flex-row items-center justify-between pt-5 mt-auto">
          <img src={depotoLogo} alt="Depoto Logo" className="sm:w-64 lg:w-auto object-contain" />
          <span className="text-base-400 uppercase">Pokladní a skladový systém</span>
        </div>
        {/*<iframe src={slideshowFrameUrl || null} frameBorder="0" style={{ width: '100%', height: '100vh' }}></iframe>*/}
      </div>
      {/*todo scrollable-y should be just tbody.. for fuck sake*/}
      <div className="w-1/2 px-5">
        {currentOrder?.items ? (
          <div className="display-item-list w-full text-left font-medium h-body flex flex-col">
            <div className="flex flex-row items-center justify-between py-4 border-b border-border-light -mx-5 px-5 mb-4">
              <div className="text-lg xl:text-xl"><FontAwesomeIcon icon={'receipt'} className="mr-1 text-primary"></FontAwesomeIcon> <span className="font-bold">Pokladní doklad</span></div>
              {currentOrder?.customer?.firstName?.length > 0 && (
                <div className="text-sm xl:text-lg"><FontAwesomeIcon icon={'user'} className="mr-1 text-primary"></FontAwesomeIcon> <span className="">{currentOrder?.customer?.firstName + ' ' + currentOrder?.customer?.lastName}</span></div>
              )}
            </div>
            <div className="p-2 text-base-400 display-item-list-row display-item-list-header font-bold flex flex-row">
              <div>Položka</div>
              <div>Počet</div>
              <div className="">Cena</div>
              <div className="">Daň</div>
              <div className="text-right">Celkem</div>
            </div>
            <div className="display-item-list-body scrollable-y overflow-hidden flex flex-col w-full" ref={orderItemsContainerRef}>
              {currentOrder.items?.length ? currentOrder.items.map(oi => (
                <div className="display-item-list-row flex flex-row mb-1 bg-white p-2 h-row border-1 boder-solid border-border-light" key={`second-display-order-item-${oi.uuid ? oi.uuid : oi.id}`}>
                  <div>
                    {oi.name}
                  </div>
                  <div>{oi.quantity}</div>
                  <div>{formatPrice(oi.priceAllWithoutVat, currency?.id)}</div>
                  <div>{oi.vat.percent}%</div>
                  <div className="text-right font-bold">{formatPrice(oi.priceAll, currency?.id)}</div>
                </div>
              )) : null}
            </div>
            <div className="-mx-5 px-5 font-bold text-black mt-auto display-price-box flex flex-row">
              <div>Celkem k úhradě</div>
              <div className="text-right">{formatPrice(currentOrder.priceAll, currency?.id)}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
